// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getPlanNamesList} from '../../shared/repositories';

export const updatePlanNames = () =>
    dispatch => {

        dispatch({
            type: actions.INCREASE_BUSY_COUNTER
        });

        return getPlanNamesList()
            .then(data => {

                dispatch({
                    type: actions.DECREASE_BUSY_COUNTER
                });

                dispatch({
                    data,
                    type: actions.UPDATE_MAINTENANCE_PLAN_PLAN_NAMES_SUCCESS
                });

            })
            .catch(() => {

                dispatch({
                    type: actions.DECREASE_BUSY_COUNTER
                });

            });

    };




// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/action-creators/update-plan-names.js